import React from 'react';
import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';

export default function Button({
  children,
  variant = 'gold',
  size = 'md',
  loading = false,
  fullWidth = false,
  className = '',
  ...props
}) {
  const base = fullWidth ? 'w-full ' : '';
  const sizeMap = { sm: 'text-xs px-4 py-2.5', md: 'text-sm px-6 py-3.5', lg: 'text-base px-7 py-4' };
  const variantMap = { gold: 'btn-gold', outline: 'btn-outline' };

  return (
    <motion.button
      whileTap={{ scale: 0.97 }}
      className={`${base}${variantMap[variant]} ${sizeMap[size]} ${className}`}
      disabled={loading || props.disabled}
      {...props}
    >
      {loading && <Loader2 size={16} className="animate-spin" />}
      {children}
    </motion.button>
  );
}
